var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useAsync2 } from "nate-react-api-helpers";
import { api } from "../../api/API";
import { useCallback, useEffect, useState } from "react";
import { useSyncedRef } from "../SyncedRef";
export function useSubmittalPreferences(props) {
    const [lastSubmission, setLastSubmission] = useState(null);
    const result = useAsync2(input => { return getSubmittalPreferences(input); }, { project: props.project, kind: props.kind }, [props.project, props.kind]);
    const onLoadRef = useSyncedRef(props.onLoad);
    const onLoadDeps = props.onLoadDeps || [];
    const onBlankRef = useSyncedRef(props.onBlank);
    useEffect(() => {
        if (!result.result)
            return;
        setLastSubmission(result.result.lastSubmission);
        try {
            if (result.result.value !== null) {
                onLoadRef.current(result.result.value);
            }
            else if (onBlankRef.current) {
                onBlankRef.current();
            }
        }
        catch (e) {
            console.error(e);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [result.result, onLoadRef, ...onLoadDeps]);
    const save = useCallback((input) => __awaiter(this, void 0, void 0, function* () { yield api.submission.setPreferences({ project: props.project, kind: props.kind, value: JSON.stringify(input) }); }), [props.kind, props.project]);
    return { lastSubmission, loading: result.loading, save };
}
export function getSubmittalPreferences(input) {
    return __awaiter(this, void 0, void 0, function* () { const prefs = yield api.submission.getPreferences(input); try {
        const value = JSON.parse(prefs.value);
        return { lastSubmission: prefs.lastSubmission, value: value };
    }
    catch (e) {
        console.error(e);
        return { lastSubmission: prefs.lastSubmission, value: null };
    } });
}
